import type { TAttachmentType } from '@doutorsim/shared/exposed/application-attachments'

export const FILE_TYPE_LABELS: Record<TAttachmentType, string> = {
  'disbursement-proof': 'Comprovante de Desembolso',
  'signed-contract': 'Contrato Assinado',
  'disbursement-receipt': 'Nota Fiscal de Recebimento',
  other: 'Outro',
}
